import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { ReceivedProductsDataInterface } from "../../../../redux/interfaces/inventory.interface";
import { dateToString } from "../../../../utils/dateAndTime";

export const inventoryTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Denumire produs",
    value: "numeProdus",
    withSearch: true,
    minW: 200,
  },
  {
    value: "Data receptiei",
    minW: 125,
  },
  {
    label: "Furnizor",
    value: "numeFurnizor",
    withSearch: true,
    minW: 125,
  },
  {
    label: "Lot",
    value: "lot",
    withSearch: true,
    minW: 125,
  },
  {
    value: "BBD",
    minW: 125,
  },
  {
    value: "Cantitate",
    minW: 125,
  },
  {
    label: "Facturi",
    value: "codFactura",
    width: 350,
    withSearch: true,
  },
];

export const getInventoryTableData = (
  data: ReceivedProductsDataInterface[],
): TableData[] =>
  data.map((item) => {
    return {
      id: item.idReceptie,
      crudData: item,
      data: [
        {
          title: item.numeProdusErp,
        },
        {
          badges: [
            {
              badgeText: dateToString(item.dataReceptie),
              badgeColor: "light-info",
            },
            {
              badgeText: item.oraReceptie,
              badgeColor: "light-info",
            },
          ],
        },
        {
          title: item.numeFurnizor,
        },
        {
          title: item.lot,
        },
        {
          badges: [
            {
              badgeText: `${dateToString(item.dataExpirare ?? "-")}`,
              badgeColor: "light-danger",
            },
          ],
        },
        {
          title: item.totalCantitate,
        },
        {
          title: item.facturi.length ? item.facturi.join(", ") : "-",
        },
      ],
    };
  });
